<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 사업장 -->
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-datepicker
            type="year"
            default="today"
            label="기준년도"
            name="trustYear"
            v-model="searchParam.trustYear"
          />
        </div>
      </template>
    </c-search-box>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <c-table
          ref="table"
          title="월별 폐수 발생량/처리량 목록"
          tableId="processManual"
          :columns="grid.columns"
          :gridHeight="grid.height"
          :data="grid.data"
          :columnSetting="false"
          :isFullScreen="false"
          :usePaging="false"
          :expandAll="true"
          @linkClick="linkClick"
        >
          <!-- 버튼 영역 -->
          <template slot="table-button">
            <q-btn-group outline >
              <!-- <c-btn label="올바로데이터 업로드" icon="add" @btnClicked="openUpload" /> -->
              <c-btn label="등록" v-if="editable" icon="add" @btnClicked="linkClick" />
              <c-btn label="검색" icon="search" @btnClicked="getList" />
            </q-btn-group>
          </template>
        </c-table>
      </div>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'waste-report-manage',
  data() {
    return {
      grid: {
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            label: '사업장',
            align: 'center',
            style: 'width: 150px',
            sortable: true,
          },
          {
            name: 'trustYm',
            field: 'trustYm',
            label: '기준월',
            align: 'center',
            type: 'link',
            sortable: true,
          },
          {
            name: 'salesVolume',
            field: 'salesVolume',
            type: 'cost',
            label: '제품 생산량(kg)',
            align: 'center',
            sortable: true,
          },
          // {
          //   name: 'waterVolume',
          //   field: 'waterVolume',
          //   type: 'cost',
          //   label: '상수도 사용량(kg)',
          //   align: 'center',
          //   sortable: true,
          // },
          // {
          //   name: 'wasteVolume',
          //   field: 'wasteVolume',
          //   type: 'cost',
          //   label: '오수 발생량(kg)',
          //   align: 'center',
          //   sortable: true,
          // },
          {
            name: 'totalVolume',
            field: 'totalVolume',
            type: 'cost',
            label: '총 폐수 발생량(kg)',
            align: 'center',
            sortable: true,
          },
          {
            name: 'trustVolume',
            field: 'trustVolume',
            type: 'cost',
            label: '폐수 위탁 처리량(kg)',
            align: 'center',
            sortable: true,
          },
          {
            name: 'reVolume',
            field: 'reVolume',
            type: 'cost',
            label: '폐수 재이용 처리량(kg)',
            align: 'center',
            sortable: true,
          },
        ],
        data: [],
      },
      searchParam: {
        trustYear: '',
        plantCd: null,
      },
      editable: true,
      listUrl: '',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        isFull: false,
        width: '50%',
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.listUrl = selectConfig.env.water.trust.list.url;
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    linkClick(row) {
      this.detailPopup(row);
    },
    detailPopup(result) {
      this.popupOptions.target = () => import(`${"./waterVolumnDetail.vue"}`);
      this.popupOptions.title = '폐수 처리 상세 내역';
      this.popupOptions.param = {
        waterTrustVolumeId: result ? result.waterTrustVolumeId : '',
      };
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>
